export default "__VITE_ASSET__whizF8wT__"